import type { FaireProductEntity } from "../../entity_types/product";

export const p_8yruy60bvy: FaireProductEntity = {
  token: "p_8yruy60bvy",
  type: "product",
  name: "Digestive™ Plant-Powered Lozenges with Ginger, Peppermint",
  brandToken: "b_dsnudsdke8",
  brandName: "Essential Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/04b3ffe8d4f2847239299f30a92936cb876eadcde9838392b4dcfb18b4276b7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59776df12f8e1e6b8f1e0b1eaa9b45327edfba18adfdeb4eb62263157edac41c.jpeg",
    "https://cdn.faire.com/fastly/4b000af37107166d830446be841eb5c6f91cf07b3f97e174210293f15495e6f5.png",
    "https://cdn.faire.com/fastly/e7eb3d9ad80b5c415268c131748005db2805263f3bbf90b77d13c02ab7dce57e.png",
    "https://cdn.faire.com/fastly/3cd99ff6b06d1027ebba3618e2d1771b2b08acea348cd6a07804174e9dcc4a63.png",
    "https://cdn.faire.com/fastly/348444582a87a38809d363f6e35f5de75a154b43c5bf5cc0037cf2fece241e10.png",
    "https://cdn.faire.com/fastly/c568cb09ba0cf4da0419d04d975ea1d8eac73d12edbbd0f18e6ff04ad21d1e06.png",
  ],
  priceDollars: 9.63,
  description:
    "Digestive Plant-Powered Lozenges™\n(formerly Digestive Blend™)\nNow USDA Organic Certified, Gluten-Free Certified, Vegan Certified\n\nSoothe your stomach and support everyday digestive comfort with our Digestive Support Plant Powered Lozenges™. Crafted with four trusted botanicals, this refreshing blend helps ease occasional stomach upset, bloating, nausea, and travel-related digestive discomfort.\n\n🍋 Lemon Comfort – Bright and zesty, lemon naturally supports healthy digestion and refreshes the palate.\n🌱 Ginger Warmth – A time-honored root known to calm the stomach and ease occasional nausea or indigestion.\n🌿 Cool Peppermint – Refreshing menthol notes that relax the digestive tract and provide a soothing sensation.\n🌾 Slippery Elm – Traditionally used to coat and calm, supporting relief from digestive irritation.\n\nEach lozenge is made with organic, plant-powered ingredients—providing a natural and flavorful way to support your gut health and enjoy greater comfort every day.",
  tags: [],
  msrpDollars: 19.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:28.645Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
